import { Fragment, useCallback, useEffect, useRef } from 'react';

//Import Scrollbar
import SimpleBar from 'simplebar-react';

// MetisMenu
import MetisMenu from 'metismenujs';
import { Link } from 'react-router-dom';

import { menuItems, MenuItemProps } from './Menu';

import classNames from 'classnames';

//Import Icons
import Icon from '@ailibs/feather-react-ts';
import { Flex, FlexProps } from '@chakra-ui/react';
import { isFeatherIcon } from './utils';

interface HeaderMenuItemProps {
  item: MenuItemProps;
}
const HeaderMenuItem = ({ item }: HeaderMenuItemProps) => {
  return (
    <li className='menu-title' data-key='t-layouts'>
      {item.label}
    </li>
  );
};

const MenuItem = ({ item }: any) => {
  const hasChildren = item['subItems'] && item['subItems'].length;
  const url = item['link'] ?? '/';
  const hasExtra = item['novidade'];
  const arrowclass = item['label'] == 'Authentication';
  const isHomePage = location?.pathname === '/';
  let isActive: boolean;

  if (isHomePage) {
    isActive = item?.link === '/';
  } else {
    isActive = item?.link !== '/' ? location.pathname.includes(item?.link as string) : false;
  }

  return (
    <li className={classNames({ 'mm-active': isActive })}>
      <Link
        to={url}
        className={classNames({ 'has-arrow': hasChildren && !hasExtra && !arrowclass }, { 'waves-effect': hasChildren })}
      >
        {item['icon'] && isFeatherIcon(item.icon) ? (
          <Icon name={item['icon']} className='icon nav-icon' size='24px' />
        ) : (
          item.icon
        )}
        <span className='menu-item'>{item.label}</span>
        {item.badge && <span className={'badge rounded-pill ' + item.badgecolor}>{item.badge}</span>}
      </Link>
      {hasChildren && <Menu item={item} />}
    </li>
  );
};

const Menu = ({ item }: { item: MenuItemProps }) => {
  const menuItems = item['subItems'] && item['subItems'];
  return (
    <ul className='sub-menu'>
      {(menuItems || []).map((item: any, key: number) => (
        <MenuItem item={item} key={key} />
      ))}
    </ul>
  );
};

export const SidebarContent = (props: FlexProps) => {
  const ref = useRef<any>();

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu('#side-menu');
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Flex
      {...props}
      sx={{
        '.sidebar-menu-scroll': {
          flex: 1,
        },
      }}
    >
      <SimpleBar ref={ref} className='sidebar-menu-scroll' id='nav-scroll'>
        <div id='sidebar-menu'>
          <ul className='metismenu list-unstyled' id='side-menu'>
            {menuItems?.map((item, key) => (
              <Fragment key={key}>{item.isHeader ? <HeaderMenuItem item={item} /> : <MenuItem item={item} />}</Fragment>
            ))}
          </ul>
        </div>
      </SimpleBar>
    </Flex>
  );
};

export default SidebarContent;
